module.exports = __webpack_public_path__ + "static/media/CITA-LandingPage-Social-Image.cbc73d88.jpg";